/**
 * Common nationalities with German and English translations.
 * Sorted alphabetically by German name.
 */
export const NATIONALITIES: ReadonlyArray<{ de: string; en: string }> = [
  { de: 'Afghanisch', en: 'Afghan' },
  { de: 'Ägyptisch', en: 'Egyptian' },
  { de: 'Albanisch', en: 'Albanian' },
  { de: 'Algerisch', en: 'Algerian' },
  { de: 'Amerikanisch', en: 'American' },
  { de: 'Angolanisch', en: 'Angolan' },
  { de: 'Argentinisch', en: 'Argentine' },
  { de: 'Armenisch', en: 'Armenian' },
  { de: 'Aserbaidschanisch', en: 'Azerbaijani' },
  { de: 'Äthiopisch', en: 'Ethiopian' },
  { de: 'Australisch', en: 'Australian' },
  { de: 'Bangladeschisch', en: 'Bangladeshi' },
  { de: 'Belgisch', en: 'Belgian' },
  { de: 'Bolivianisch', en: 'Bolivian' },
  { de: 'Bosnisch-herzegowinisch', en: 'Bosnian' },
  { de: 'Brasilianisch', en: 'Brazilian' },
  { de: 'Britisch', en: 'British' },
  { de: 'Bulgarisch', en: 'Bulgarian' },
  { de: 'Chilenisch', en: 'Chilean' },
  { de: 'Chinesisch', en: 'Chinese' },
  { de: 'Costaricanisch', en: 'Costa Rican' },
  { de: 'Dänisch', en: 'Danish' },
  { de: 'Deutsch', en: 'German' },
  { de: 'Dominikanisch', en: 'Dominican' },
  { de: 'Ecuadorianisch', en: 'Ecuadorian' },
  { de: 'Eritreisch', en: 'Eritrean' },
  { de: 'Estnisch', en: 'Estonian' },
  { de: 'Finnisch', en: 'Finnish' },
  { de: 'Französisch', en: 'French' },
  { de: 'Georgisch', en: 'Georgian' },
  { de: 'Ghanaisch', en: 'Ghanaian' },
  { de: 'Griechisch', en: 'Greek' },
  { de: 'Guatemaltekisch', en: 'Guatemalan' },
  { de: 'Haitianisch', en: 'Haitian' },
  { de: 'Honduranisch', en: 'Honduran' },
  { de: 'Indisch', en: 'Indian' },
  { de: 'Indonesisch', en: 'Indonesian' },
  { de: 'Irakisch', en: 'Iraqi' },
  { de: 'Iranisch', en: 'Iranian' },
  { de: 'Irisch', en: 'Irish' },
  { de: 'Isländisch', en: 'Icelandic' },
  { de: 'Israelisch', en: 'Israeli' },
  { de: 'Italienisch', en: 'Italian' },
  { de: 'Jamaikanisch', en: 'Jamaican' },
  { de: 'Japanisch', en: 'Japanese' },
  { de: 'Jemenitisch', en: 'Yemeni' },
  { de: 'Jordanisch', en: 'Jordanian' },
  { de: 'Kambodschanisch', en: 'Cambodian' },
  { de: 'Kamerunisch', en: 'Cameroonian' },
  { de: 'Kanadisch', en: 'Canadian' },
  { de: 'Kasachisch', en: 'Kazakh' },
  { de: 'Kenianisch', en: 'Kenyan' },
  { de: 'Kolumbianisch', en: 'Colombian' },
  { de: 'Kongolesisch', en: 'Congolese' },
  { de: 'Koreanisch', en: 'Korean' },
  { de: 'Kosovarisch', en: 'Kosovar' },
  { de: 'Kroatisch', en: 'Croatian' },
  { de: 'Kubanisch', en: 'Cuban' },
  { de: 'Kuwaitisch', en: 'Kuwaiti' },
  { de: 'Laotisch', en: 'Laotian' },
  { de: 'Lettisch', en: 'Latvian' },
  { de: 'Libanesisch', en: 'Lebanese' },
  { de: 'Liberianisch', en: 'Liberian' },
  { de: 'Libysch', en: 'Libyan' },
  { de: 'Litauisch', en: 'Lithuanian' },
  { de: 'Luxemburgisch', en: 'Luxembourgish' },
  { de: 'Malaysisch', en: 'Malaysian' },
  { de: 'Malisch', en: 'Malian' },
  { de: 'Maltesisch', en: 'Maltese' },
  { de: 'Marokkanisch', en: 'Moroccan' },
  { de: 'Mauretanisch', en: 'Mauritanian' },
  { de: 'Mexikanisch', en: 'Mexican' },
  { de: 'Moldauisch', en: 'Moldovan' },
  { de: 'Mongolisch', en: 'Mongolian' },
  { de: 'Montenegrinisch', en: 'Montenegrin' },
  { de: 'Mosambikanisch', en: 'Mozambican' },
  { de: 'Myanmarisch', en: 'Burmese' },
  { de: 'Namibisch', en: 'Namibian' },
  { de: 'Nepalesisch', en: 'Nepalese' },
  { de: 'Neuseeländisch', en: 'New Zealander' },
  { de: 'Nicaraguanisch', en: 'Nicaraguan' },
  { de: 'Niederländisch', en: 'Dutch' },
  { de: 'Nigerianisch', en: 'Nigerian' },
  { de: 'Nigrisch', en: 'Nigerien' },
  { de: 'Nordmazedonisch', en: 'North Macedonian' },
  { de: 'Norwegisch', en: 'Norwegian' },
  { de: 'Österreichisch', en: 'Austrian' },
  { de: 'Pakistanisch', en: 'Pakistani' },
  { de: 'Palästinensisch', en: 'Palestinian' },
  { de: 'Panamaisch', en: 'Panamanian' },
  { de: 'Paraguayisch', en: 'Paraguayan' },
  { de: 'Peruanisch', en: 'Peruvian' },
  { de: 'Philippinisch', en: 'Filipino' },
  { de: 'Polnisch', en: 'Polish' },
  { de: 'Portugiesisch', en: 'Portuguese' },
  { de: 'Rumänisch', en: 'Romanian' },
  { de: 'Russisch', en: 'Russian' },
  { de: 'Salvadorianisch', en: 'Salvadoran' },
  { de: 'Sambisch', en: 'Zambian' },
  { de: 'Saudi-arabisch', en: 'Saudi' },
  { de: 'Schwedisch', en: 'Swedish' },
  { de: 'Schweizerisch', en: 'Swiss' },
  { de: 'Senegalesisch', en: 'Senegalese' },
  { de: 'Serbisch', en: 'Serbian' },
  { de: 'Simbabwisch', en: 'Zimbabwean' },
  { de: 'Singapurisch', en: 'Singaporean' },
  { de: 'Slowakisch', en: 'Slovak' },
  { de: 'Slowenisch', en: 'Slovenian' },
  { de: 'Somalisch', en: 'Somali' },
  { de: 'Spanisch', en: 'Spanish' },
  { de: 'Sri-lankisch', en: 'Sri Lankan' },
  { de: 'Südafrikanisch', en: 'South African' },
  { de: 'Sudanesisch', en: 'Sudanese' },
  { de: 'Südkoreanisch', en: 'South Korean' },
  { de: 'Syrisch', en: 'Syrian' },
  { de: 'Taiwanisch', en: 'Taiwanese' },
  { de: 'Tansanisch', en: 'Tanzanian' },
  { de: 'Thailändisch', en: 'Thai' },
  { de: 'Togoisch', en: 'Togolese' },
  { de: 'Tschechisch', en: 'Czech' },
  { de: 'Tunesisch', en: 'Tunisian' },
  { de: 'Türkisch', en: 'Turkish' },
  { de: 'Ugandisch', en: 'Ugandan' },
  { de: 'Ukrainisch', en: 'Ukrainian' },
  { de: 'Ungarisch', en: 'Hungarian' },
  { de: 'Uruguayisch', en: 'Uruguayan' },
  { de: 'Usbekisch', en: 'Uzbek' },
  { de: 'Venezolanisch', en: 'Venezuelan' },
  { de: 'Vietnamesisch', en: 'Vietnamese' },
  { de: 'Weißrussisch', en: 'Belarusian' },
  { de: 'Zyprisch', en: 'Cypriot' },
];
